module.exports = __webpack_public_path__ + "static/logo-alt-ae8281fd64166dc62bf18c0ea549e0bf.png";